import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import PageTitle from 'components/atoms/PageTitle'
import PartnerInventoryTable from 'components/organisms/PartnerInventoryTable'

import {
  ROLE_LOGISTICS,
  ROLE_PARTNER_READ_ONLY,
  ROLE_READ_ONLY,
  ROLE_TEAM_RELEASE,
  useAuth,
} from '../../auth'

export default function PartnerInventory() {
  const { t } = useTranslation()
  const { hasOneOfRoles } = useAuth()
  const userRoleHasReadOnly = useMemo(
    () =>
      hasOneOfRoles([
        ROLE_READ_ONLY,
        ROLE_LOGISTICS,
        ROLE_PARTNER_READ_ONLY,
        ROLE_TEAM_RELEASE, // REL-F07: teamRelease vede l'inventario read-only
        // ROLE_POST_SALES,
      ]),
    [hasOneOfRoles]
  )

  return (
    <div className="content-container">
      <PageTitle label={t('partnerInventory.title')} />
      <PartnerInventoryTable contentIsReadOnly={userRoleHasReadOnly} />
    </div>
  )
}
